document.addEventListener("DOMContentLoaded", function () {
  const swiperSlider = new Swiper(
    ".swiper:not(.gallery-swiper):not(.gallery-thumbs)",
    {
      loop: true,
      effect: "slide",
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }
  );

  const thumbs = new Swiper(".gallery-thumbs", {
    spaceBetween: 10,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".btn-next",
      prevEl: ".btn-prev",
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 6,
      },
    },
  });

  const main = new Swiper(".gallery-swiper", {
    loop: true,
    effect: "slide",

    slideToClickedSlide: true,
    navigation: {
      nextEl: ".btn-next",
      prevEl: ".btn-prev",
    },

    thumbs: {
      swiper: thumbs,
    },
  });
});
